import React, { useState } from "react";
import { Box, HStack, VStack, IconButton, Icon, Heading, Text, Input } from "@chakra-ui/react"
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
    const [identifier, setIdentifier] = useState("");
    const navigate = useNavigate();

    return (
        <Box display={"flex"} width={"100vw"} height={"100vh"} position={"relative"}>
            <VStack width={"full"} height={"full"} justifyContent={"center"}>
                <Heading>
                    Welcome to AssistXR companion app.
                </Heading>
                <Text>
                    Please enter your identifier:
                </Text>
                <HStack>
                    <Input type="text" placeholder="AAAAAAAAAA" value={identifier} onChange={(event) => setIdentifier(event?.target?.value)} />
                    <IconButton icon={<Icon as={FaArrowRight} boxSize={"20px"} />} onClick={() => navigate(`/${identifier}`)} isDisabled={!identifier || identifier.length !== 10} />
                </HStack>
            </VStack>
        </Box>
    );
}

export default React.memo(HomePage);
